<template>
  <div>
    <div
      v-if="detail_loader"
    style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)"
    >
      <div class="text-xs-center">
        <v-progress-circular
           :size="70"
           :width="7"
           indeterminate
           color="#ff9233"
          class="text-xs-center my-5"
          large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 md12 lg12  mt-3>
          <v-card
            ><br />
             <v-card-text>
               <v-layout row wrap class="text-xs-left">
                 <v-flex xs12 md6 mt-3>
                   <b>User Name: </b>
                   <br>
                   <span style="color: #9e9e9e" disabled>{{
                       suggestion_detail.first_name
                     }}</span>
                 </v-flex>
                 <v-flex xs12 md6 mt-3>
                   <b>Email ID</b>
                   <br>
                   <span style="color: #9e9e9e" disabled>{{
                       suggestion_detail.email_id
                     }}</span>
                 </v-flex>
                 <v-flex xs12 md6 mt-3>
                   <b>Criticality</b>
                   <br>
                   <span style="color: #9e9e9e" disabled>{{
                       suggestion_detail.criticality
                     }}</span>
                 </v-flex>

                 <v-flex xs12 md6 mt-3>
                   <b>Suggestion</b>
                   <br>
                   <span style="color: #9e9e9e" disabled
                   >{{suggestion_detail.suggestion }}
                   </span>
                 </v-flex>
               </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Delete Resource dialog box -->
      <v-snackbar
        :color="snack_bar.color"
        :top="snack_bar.top"
        :bottom="snack_bar.bottom"
        :left="snack_bar.left"
        :right="snack_bar.right"
        v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Detail",

  data: () => {
    return {
      suggestion_detail: {},
      detail_loader: false,
      snack_bar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,

      },
    };
  },
  
  methods: {

    getSuggestionDetail: function () {
      this.detail_loader = true;

      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/v1/feature-suggestion-details/` +
            this.$route.params.id,
          { headers: this.$headers }
        )
        .then((response) => {
          if (response.data.status == 1) {
            // console.log(response.data.suggestion);return;
            this.suggestion_detail = response.data.suggestion;
            this.detail_loader = false;
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    },
  },
  mounted() {
    this.getSuggestionDetail();
  },
};
</script>


